export default __webpack_public_path__ + "static/7-small-40f20b87762bea937be8cac8c03407b1.jpg";